import { render, staticRenderFns } from "./ConfirmTrustedDataDialog.vue?vue&type=template&id=6a0c66bb&scoped=true"
import script from "./ConfirmTrustedDataDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmTrustedDataDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmTrustedDataDialog.vue?vue&type=style&index=0&id=6a0c66bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c66bb",
  null
  
)

export default component.exports